


































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { AsyncComputed } from '@/AsyncComputed';
import CompanyStore, { CompanyStatus } from '@/store/CompanyStore';
import PreferenceStore, { VDataTablePagenation } from '@/store/PreferenceStore';
import AppStore from '@/store/App';
import MaterialCard from '@/components/material/Card.vue';
import Refreshable from '@/components/helper/Refreshable.vue';
import delay from 'delay';

function hiraToKana(str: string) {
    return str.replace(/[\u3041-\u3096]/g, function(match) {
        var chr = match.charCodeAt(0) + 0x60;
        return String.fromCharCode(chr);
    });
}

@Component({
  metaInfo() {
    return {
      title: "会社一覧",
    }
  },
  components: {
      MaterialCard,
      Refreshable,
  }
})
export default class CompanyList extends Vue {
    headers = [
      {
          sortable: false,
          text: '',
      },
      {
          sortable: false,
          text: '',
      },
      {
        sortable: true,
        text: '会社名',
        value: 'name'
      },
      {
        sortable: true,
        text: '会社ID',
        value: 'id'
      },
      {
        sortable: true,
        text: 'DB名',
        value: 'id'
      },
      {
        sortable: true,
        text: '契約日',
        value: 'startDate',
        sort(a: Date, b: Date) {
          return a.valueOf() - b.valueOf();
        }
      },
      {
        sortable: true,
        text: '契約状況',
        value: 'contractStatus'
      },
      /*{
        sortable: true,
        text: '店舗数',
        value: 'branchNumber'
      },*/
    ];
    refreshing = false;

    /* selection */
    selections: { [key: number]: CompanyStatus | undefined } = {};
    selectionCount: number = 0;
    selectedItems(): (CompanyStatus | undefined)[] { 
        return Object.values(this.selections);
    }
    toggleSelection(id: number, val: CompanyStatus | undefined) {
        if(this.selections[id] && !val) this.selectionCount--;
        else if(!this.selections[id] && val) this.selectionCount++;
        this.selections[id] = val;
    }

    @AsyncComputed({
        get: async function(this: CompanyList): Promise<CompanyStatus[]> { 
            this.refreshing = true;
            let text = AppStore.searchText;
            const list = await CompanyStore.getStatusList();
            this.refreshing = false;

            // extract search text
            if(!text) return list;
            text = text.toLowerCase();
            const match = text.match(/^([あ-んー]+)[ａ-ｚ]?$/);
            if(!match) return list.filter(x => x.name && x.name.toLowerCase().indexOf(text) != -1);
            const yomi = hiraToKana(match[1]);
            return list.filter(x => x.kana && x.kana.indexOf(yomi) != -1);
        },
        default: []
    })
    items: CompanyStatus[] = undefined as any;

    async refresh() {
        this.refreshing = true;
        const d500 = delay(500);
        const update = CompanyStore.updateStatus();
        await Promise.all([d500, update]);
        this.refreshing = false;
    }

    get pagination() {
      console.log(JSON.stringify(PreferenceStore.companyTableState));
        return PreferenceStore.companyTableState;
    }
    set pagination(val) {
        if(this.items.length > 0)
            PreferenceStore.UPDATE_COMPANY_TABLE_STATE(val);
    }

    async makeInvisible() {
        const dialogResult = await AppStore.showConfirm({ message: '一旦会社を非表示にするとデータベースを編集しない限り見ることができません。本当に非表示にしてよろしいですか？',  caption: '確認' });
        if(!dialogResult) return;
        console.log(this.selectedItems());

        const promises = this.selectedItems().map(x => x && CompanyStore.modifyDetail({ id: x.sid, mods: { version: x.version * -1 } }));
        await Promise.all(promises);

        AppStore.showSuccess('正常に更新しました。');
    }
}
